import React from 'react';
import './Sidebar.css';



const LeftSideItem = ({name,Icon}) => {
    return (
        <div className="leftSideItem ">
            <h5 className="mt-2"> {<Icon/>} {name}</h5>  
           
        </div>
    ); 
}; 
 
export default LeftSideItem;